import { Card, CardContent, Grid, Typography } from "@mui/material";
import { injectIntl } from "react-intl";
import clsx from 'clsx'
import { makeStyles } from "@mui/styles";
import { PapiroConsole } from "src/utils/papiroConsole";

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
    },
    content: {
        alignItems: 'center',
        display: 'flex'
    },
    title: {
        fontWeight: 700
    },
    avatar: {
        backgroundColor: theme.palette.error.main,
        height: 56,
        width: 56
    },
    icon: {
        height: 32,
        width: 32
    },
    difference: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center'
    },
    differenceIcon: {
        color: theme.palette.error.dark
    },
    differenceIconSucess: {
        color: 'green'
    },
    differenceValue: {
        color: theme.palette.error.dark,
        marginRight: theme.spacing(1)
    }
}))

const HeaderCard = (props) => {
    const { title, value, className } = props
    const classes = useStyles()

    return (
        <Grid item xs={12} sm={2} >
            <Card
                className={clsx(classes.root, className)}
            >
                <CardContent >
                    <Grid
                        container
                        justify="space-between"
                    >
                        <Grid style={{ maxWidth: '80%' }} item xs={10} sm={10} md={11} lg={11}>
                            <Typography
                                className={classes.title}
                                color="textSecondary"
                                gutterBottom
                                variant="body2"
                            >
                                {title}
                            </Typography>
                            <Typography variant="h3">
                                {value}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default injectIntl(HeaderCard)